import get from 'lodash/get';

import NFPA from './NFPA.js';

// The text of the standards the OFC Minimum Standards cite — NFPA sections and
// WorkSafeBC OHS Regulation Part 31 — and the lookup from a JPR key
// ("1001:2019:4.3.9", "WorksafeBC:31.10") to its section. Browser-only reference
// material, shared so the hub's Training Matrix dialog shows a JPR exactly as the
// department app's does (#2294). The OFC catalog that cites these keys is in
// @embertracking/common (data/standards/ofc.mjs), where the api can reach it.

export {NFPA};

export const WorksafeBC = {
    31: {
        1: {
            title: 'Definitions',
            text: 'In this Part "emergency incident" means a specific emergency operation of a fire department or industrial fire brigade; "fire chief" means the highest ranking person in charge of a fire department or industrial fire brigade; "fire department" means a fire brigade operated as a public service by\n\n(a) a municipality, a regional district or an improvement district,\n\n(b) a board or commission having the management or conduct of work or services on behalf of any of the bodies referred to in paragraph (a), or\n\n(c) a parks board.\n\n"firefighter" means any worker employed in firefighting, fire inspection, fire investigation, the maintenance of firefighting equipment, the training for and direction of those activities, or other similar duties; "firefighting vehicle" means an emergency vehicle used for firefighting; "incident commander" means the firefighter in overall command of an emergency incident; "industrial fire brigade" means an organization established by an employer to protect the employer\'s premises where the nature of the business creates specific hazards for which specialized training and equipment is required; "structure" means a building, vehicle, vessel or similar enclosed location.'
        },
        2: {
            title: 'Application',
            text: 'This Part applies to employers and to workers who are employed in firefighting activities on a full or part time basis, including volunteer firefighting in municipal service and industrial fire brigades to which the compensation provisions of the Workers Compensation Act apply, but does not apply to forest fire fighting.'
        },
        3: {
            title: 'Health and Safety Committee',
            text: '(1) If an employer is required under 4) must not engage OHS provisions of the Workers Compensation Act to establish a joint commitee or worker health and safety representative, then a fire department or industrial fire brigade operated by the employer must have a separate joint committee or worker health and safety representative, as applicable.\n\n(2) Subsection (1) does not affect any obligation to have a workplace health and safety program for the whole of the employer\'s operations.'
        },
        4: {
            title: 'Instruction and direction',
            text: 'The employer must ensure the adequate instruction and direction of firefighters in the safe performance of their duties.'
        },
        5: {
            title: 'Procedures',
            text: '(1) Written procedures must be established and followed by a fire department or industrial fire brigade to\n\n(a) manage and track firefighters at an emergency incident,\n\n(b) manage exposure to bloodborne pathogens,\n\n(c) manage stress arising from an emergency incident that is likely to cause adverse health effect to firefighters,\n\n(d) provide for effective traffic control at emergency incidents, and\n\n(e) operate firefighting vehicles during emergency and non-emergency travel.\n\n(2) Written procedures must be established and followed by a fire department or industrial fire brigade for the following situations, where applicable:\n\n(a) fires in buildings 7 storeys or over;\n\n(b) firefighting over water and underground;\n\n(c) fires and other emergency incidents involving hazardous substances;\n\n(d) rescue from high angles, confined spaces, trenches, excavations and water;\n\n(e) disaster planning and response;\n\n(f) electrical emergencies.'
        },
        6: {
            title: 'Rest and rehabilitation',
            text: 'The incident commander must make suitable provision for rest and rehabilitation for firefighters at an emergency incident.'
        },
        7: {
            title: 'Impounding equipment',
            text: 'If, in the course of an emergency incident, a firefighter suffers serious injury or death, or is involved in an accident involving a risk of serious injury or death, the senior firefighter present must immediately impound the protective and other equipment used by the firefighter and keep the equipment out of service until released by the Board.'
        },
        8: {
            title: 'Equipment defects',
            text: 'The employer must, without delay, notify the Board of any structural failure or manufacturing defects detected in a firefighting vehicle, apparatus, or other emergency equipment referred to in this Part.'
        },
        9: {
            title: 'Test records',
            text: 'The employer must keep the test and inspection records required by this part available at the workplace for inspection by an officer or the joint committee or worker health and safety representative, as applicable.'
        },
        10: {
            title: 'General requirement',
            text: 'Firefighters must wear personal protective clothing and equipment appropriate to the hazards to which they may be exposed.'
        },
        11: {
            title: 'Maintenance',
            text: '(1) The employer must have written procedures for the inspection of protective clothing and equipment at regular intervals.\n\n(2) Procedures for cleaning and drying protective clothing must be in accordance with the manufacturer\'s instructions.\n\n(3) Defective items of protective clothing or equipment must be repaired or replaced.'
        },
        12: {
            title: 'Firefighter responsibility',
            text: 'Firefighters must ensure that the personal protective clothing and equipment used by them is maintained in good condition.'
        },
        13: {
            title: 'Safety headgear',
            text: '(1) Safety headgear must be worn by firefighters required to approach the seat of a fire or enter a structure or other hazardous area during an incident.\n\n(2) Safety headgear must meet the requirements of NFPA 1972, Helmets for Structural Firefighting: Structural Fire Fighters Helmets, 1992 Edition.\n\n(3) Headgear meeting the requirements for safety headgear in Part 8 (Personal Protective Clothing and Equipment) may be used by firefighters\n\n(a) while determining the cause of fires, or carrying out duties associated with preventing fires, or\n\n(b) at the discretion of the incident commander, while fighting a fire in vegetation that is not within a structure.'
        },
        14: {
            title: 'Protective coats, pants and hoods',
            text: 'Firefighters required to approach the seat of a fire or enter a structure or other hazardous area during an incident must wear protective coats, pants and hoods meeting the requirements of\n\n(a) NFPA 1971, Protective Clothing for Structural Fire Fighting, 1991 Edition, or\n\n(b) CGSB Standard CAN/CGSB-155.1-M88, Firefighters\' Protective Clothing for Protection Against Heat and Flame.'
        },
        15: {
            title: 'Stationwear and personal garments',
            text: 'Firefighters required to approach the seat of a fire or enter a structure or other hazardous area during an emergency incident must not wear shirts, trousers, jackets or coveralls that have poor thermal stability or that ignite easily.'
        },
        16: {
            title: 'Working gloves',
            text: 'Firefighters required to approach the seat of a fire or enter a structure or other hazardous area during an emergency incident must wear gloves meeting the requirements of NFPA 1973, Gloves for Structural Fire Fighting, 1988 Edition.'
        },
        17: {
            title: 'Fall Protection',
            text: '(1) A firefighter working on an aerial ladder must wear a safety belt and lanyard meeting the requirements of CSA Standard Z259.1-95, Safety Belts and Lanyards, and the securing lanyard must limit a fall to no more than 30 cm (12 in).\n\n(2) A firefighter located on an aerial platform must wear a full body harness and lanyard meeting the requirements of Part 11 (Fall Protection).\n\n(3) Rescue ropes, rappelling lines and safety belts and harnesses including safety hooks, rope grabs, lowering devices, and related equipment must meet the requirements of NFPA 1983, Fire Service Life Safety Rope, Harness and Hardware, 1990 Edition.\n\n(4) The incident commander may depart from the requirements of Part 11 (Fall Protection) to use a fall protection system if, in the incident commander\'s opinion, such compliance is not practicable or may create a greater hazard, but subsections (1) to (3) of this section must be complied with.'
        },
        18: {
            title: 'Personal alert safety system',
            text: '(1) A firefighter must be provided with and use a Personal Alert Safety System (PASS) when involved in duties which require a self-contained breathing apparatus to be worn.\n\n(2) A PASS device must meet the requirements of NFPA 1982, Personal Alert Safety Systems (PASS) for Fire Fighters, 1993 Edition.\n\n(3) A PASS device must be tested at least weekly and prior to use.'
        },
        19: {
            title: 'General',
            text: 'Firefighters who may be exposed to an oxygen deficient atmosphere or to harmful concentrations of air contaminants must wear a self-contained breathing apparatus of a positive pressure type having a rated minimum duration of 30 minutes.'
        },
        20: {
            title: 'Fitness to use SCBA',
            text: 'A physician\'s certificate of fitness must be provided by a firefighter who\n\n(a) experiences breathing difficulty while using the apparatus, or\n\n(b) is known to have heart disease, impaired pulmonary function, or any other condition that might make it dangerous to use self-contained breathing apparatus.'
        },
        21: {
            title: 'Operation of SCBA',
            text: 'Respirators must be used in accordance with CSA Standard CAN/CSA-Z94.4-02, Selection, Use, and Care of Respirators, Clause 9.1.'
        },
        22: {
            title: 'Sealing and fit testing',
            text: '(1) Firefighters using SCBA must be clean shaven to ensure the mask forms a positive seal against the face.\n\n(2) Fit tests must be performed in accordance with the procedures in CSA Standard CAN/CSA-Z94.4-02.\n\n(2.1) A fit test must be carried out\n\n(a) before initial use of a respirator,\n\n(b) at least once a year,\n\n(c) whenever there is a change in respirator facepiece including brand, model, and size, and\n\n(d) whenever changes to the user\'s physical condition could affect respirator fit.\n\n(3) Personal protective equipment worn with SCBA and that might interfere with proper fit must be worn during the fit test.\n\n(4) Only corrective eyewear designed for use with SCBA may be worn.'
        },
        23: {
            title: 'Entry into buildings',
            text: [
                '(1) When self-contained breathing apparatus must be used to enter a building, or similar enclosed location, the entry must be made by a team of at least 2 firefighters.',
                '(2) Effective voice communication must be maintained between firefighters inside and outside the enclosed location.',
                '(3) During the initial attack stages of an incident at least one firefighter must remain outside.',
                '(4) A suitably equipped rescue team of at least 2 firefighters must be established on the scene before sending in a second entry team and not more than 10 minutes after the initial attack.',
                '(5) The rescue team required by subsection (4) must not engage in any duties that limit their ability to make a prompt response to rescue an endangered firefighter while interior structural firefighting is being conducted.'
            ].join('\n\n')
        },
        24: {
            title: 'Air quality and sampling',
            text: 'Air used for breathing purposes must meet the requirements of CSA Standard CAN/CSA-Z180.1-00, Compressed Breathing Air and Systems, and must be tested at least annually in a manner acceptable to the Board.'
        },
        25: {
            title: 'Spare equipment',
            text: '(1) When self-contained breathing apparatus are used, the employer must ensure at least 4 apparatus are available.\n\n(2) At least one spare compressed air cylinder having a rated minimum duration of 30 minutes must be maintained at full rated capacity and available for each self-contained breathing apparatus.'
        },
        26: {
            title: 'Maintenance and records',
            text: '(1) Self-contained breathing apparatus, including regulators, must be serviced and repaired by qualified persons.\n\n(2) Inspection of compressed air cylinders must be done in accordance with CSA Standard CAN/CSA-Z94.4-02.\n\n(3) Compressed air cylinders must be hydrostatically tested in accordance with CSA Standard CAN/CSA-B339-96.\n\n(4) Complete maintenance and repair records for each self-contained breathing apparatus and all air cylinders must be kept in accordance with CSA Standard CAN/CSA-Z94.4-02, section 10.3.3.2.2-b to f, inclusive.'
        },
        27: {
            title: 'Seating',
            text: '(1) Firefighters being transported must ride in properly secured seats equipped with seat belts providing not less than 41 cm (16 in) seating width for each occupant.\n\n(2) New firefighting vehicles ordered after April 15, 1998 must have seats equipped with headrests or other effective whiplash protection.'
        },
        28: {
            title: 'Communication',
            text: 'Crew cabs on firefighting vehicles must have an effective means of voice communication between the driver and passengers.'
        },
        29: {
            title: 'Enclosed crew cabs',
            text: '(1) Enclosed crew cabs must be equipped with interior lights and adequately ventilated.\n\n(2) New firefighting vehicles ordered after April 15, 1998 must have fully enclosed crew cabs meeting the requirements of NFPA 1901, Automotive Fire Apparatus, 1991 Edition.'
        },
        30: {
            title: 'Stowing equipment',
            text: '[Repealed by B.C. Reg. 139/2021, effective September 1, 2021]'
        },
        31: {
            title: 'Safe movement of vehicles',
            text: '[Repealed by B.C. Reg. 139/2021, effective September 1, 2021]'
        },
        32: {
            title: 'Vehicle exhaust in firehalls',
            text: 'Unless air monitoring shows that levels of vehicle exhaust gas components are below the exposure limits established under section 5.48, effective local venting for the exhaust gases must be provided in vehicle areas in firehalls.'
        },
        33: {
            title: 'General',
            text: 'An aerial device used for firefighting must meet the requirements of NFPA 1904, Aerial Ladder and Elevating Platform Fire Apparatus, 1991 Edition.'
        },
        34: {
            title: 'Inspection and testing',
            text: '(1) Fire department aerial devices must be inspected and tested in accordance with good engineering practice at intervals not exceeding 12 months and must be certified safe by a professional engineer or the equipment manufacturer.\n\n(2) Inspection and testing must be done in accordance with the requirements of NFPA 1914, Testing Fire Department Aerial Devices, 1991 Edition.'
        },
        35: {
            title: 'Controls',
            text: 'The turntable on an aerial device must be fitted with a positive locking device to hold it in any desired position.'
        },
        36: {
            title: 'Operator location',
            text: 'During the operation of an aerial device an operator must be present at the lower controls in sight of and in voice contact with any firefighters upon the device.'
        },
        37: {
            title: 'Ground ladders',
            text: '(1) A ground ladder used by firefighters must meet the requirements of NFPA 1931, Design of and Design Verification Tests for Fire Department Ground Ladders, 1989 Edition.\n\n(2) A ground ladder must be used, tested and maintained in accordance with the requirements of NFPA 1932, Use, Maintenance, and Service Testing of Fire Department Ground Ladders, 1989 Edition.'
        },
        38: {
            title: 'Flashlights and hand lanterns',
            text: 'Battery operated flashlights and hand lanterns that are CSA approved for hazardous locations classified under the CSA Standard C22.1-94, Canadian Electrical Code Part 1, as Class 1, Division 2, Groups A, B, and C must be provided as follows:\n\n(a) one flashlight for each firefighter;\n\n(b) at least 4 hand lanterns for each firefighting vehicle.'
        },
        39: {
            title: 'Plaster hooks and pike poles',
            text: 'Plaster hooks and pike poles must be fitted with electrically non-conductive shafts.'
        }
    }
};

export const getStandardForKey = key => {
    if (!key || typeof key !== 'string') {
        return;
    }

    if (/worksafebc/i.test(key)) {
        const [, ...rest] = key.split(':');
        const {title, text, ...data} = get(WorksafeBC, rest.join('.')) || {};
        
        return {
            standard: {
                title: 'WorksafeBC',
                shortTitle: 'WorksafeBC'
            },
            key: rest.join('.'),
            title,
            shortTitle: `WorksafeBC: ${rest.join('.')}`,
            text,
            data
        };
    }

    const [standard, year, ...rest] = key.split(':');
    const {title: standardTitle} = get(NFPA, standard) || {};
    if (!standardTitle) {
        console.warn('Missing Standard Title:', standard);
        return;
    }

    const path = `${standard}.editions.${year}.${rest.join('.')}`;

    const standardData = get(NFPA, path);
    if (!standardData) {
        if (standardTitle) {
            // return {
            //     standard: {
            //         title: [`NFPA ${standard}`, standardTitle].filter(Boolean).join(': '),
            //         shortTitle: `NFPA ${standard}`,
            //         standard,
            //         edition: year,
            //     },
            //     key: [standard, year].join('.')
            // };
        }

        return;
    }
    
    const sectionData = get(NFPA, `${standard}.editions.${year}.${rest.join('.')}`);
    if (!sectionData) {
        return;
    }
    
    const {title, text, ...data} = sectionData;

    return {
        standard: {
            title: [`NFPA ${standard}`, standardTitle].filter(Boolean).join(': '),
            shortTitle: `NFPA ${standard}`,
            standard,
            edition: year
        },
        key: rest.join('.'),
        title,
        shortTitle: `NFPA ${standard}: ${rest.join('.')}`,
        text,
        data,
        parent: get(NFPA, path.split('.').slice(0, -1).join('.'))
    };
};
